// The report as the automatic mails need it: the very same report page, opened by the server's own browser (to make the PDF
// that is attached) with a short-lived token instead of a login. What is in it is decided by the saved schedule, passed in the
// address after the #, which a server never receives: report type, framework, audience and the parts that follow.
//
// The token lives only in memory, is only valid for this one tenant, for reading, for ten minutes, and is deleted when the PDF
// is made (see createRenderToken in azure-function/src/lib/app.js).
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { setRenderToken } from '../api';
import { TenantDataProvider } from '../context/TenantDataContext';
import AuditReport from './AuditReport';

let read = null;
function readOptions() {
  // Read once: the address is cleaned below, so a second render must not look for the token again.
  if (!read) read = parseAddress();
  return read;
}

function parseAddress() {
  const params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
  const token = params.get('rt');
  // The address is cleaned at once, so the token is not left in the history or on screen.
  window.history.replaceState(null, '', window.location.pathname);
  return {
    token,
    options: {
      kind: params.get('type') === 'setup' ? 'setup' : 'framework',
      aud: params.get('aud') === 'led' ? 'led' : 'rev',
      fw: params.get('fw') || null,
      selected: (params.get('sel') || '').split(',').filter(Boolean),
    },
  };
}

export default function ReportRender() {
  const { tenantId } = useParams();
  const { options } = useMemo(() => {
    const opened = readOptions();
    setRenderToken(opened.token);
    return opened;
  }, []);
  return (
    <TenantDataProvider tenantId={tenantId} readOnly>
      <AuditReport render={options} />
    </TenantDataProvider>
  );
}
